export interface PreviewOptions {
  pageCount?: number;
  description?: string;
  color?: string;
}

export interface PdfPreviewDto {
  options?: PreviewOptions;
  images?: string[];
  layout?: string;
}

export interface ExcelPreview {
  options?: PreviewOptions;
  sheets?: Sheet[];
}

export interface Sheet {
  name?: string;
  pageHtml?: string;
}

export interface EmailPreview {
  htmlBody: string;
}

export interface ImagePreview {
  images: string[];
}

/**
 * Dati unificati per le anteprime file.
 * Il campo effettivamente popolato dipende dal tipo di file.
 */
export interface PreviewData {
  type: 'pdf' | 'image' | 'excel' | 'email' | 'doc' | 'text' | 'raw_image' | 'unsupported';
  pdfBlob?: Blob | null;
  wordBlob?: Blob | null;

  images?: string[];
  excelSheets?: ExcelPreview;
  emailBodyHtml?: string;
  textHtml?: string;
  rawImageUrl?: string;
}

/**
 * Estensioni di immagini native supportate dal server come blob.
 */
export const NATIVE_IMAGE_EXTENSIONS = ['jpg', 'raw_image', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
